import Search from "../../commons/search";
import Table from "../../commons/table";
import {TABLE_CONTRACT_NON_EMP_LIST} from "../../../configs/non-employee/configTableCreateContract";
import ViewList from "../../commons/view-list";

export const RegisteredNonEmployee = (
    {
        employeeListResponse,
        onSearch,
        onChangePage,
        modal,
        query,
        onChangeSize,
        modalVisibility
    }) => {

    return (
        <div>
            <div className={"flex flex-row justify-between px-6 pt-6 pb-4"}>
                <div className={"flex flex-row"}>
                    <Search className="mr-4" value={query.search} onSearch={onSearch}/>
                    <ViewList
                        show={modal?.sort}
                        onShow={() => modalVisibility({ sort: true })}
                        onClose={() => modalVisibility({ sort: false })}
                        value={query?.limit}
                        onSelectSize={onChangeSize}
                    />
                </div>
            </div>
            <Table
                className="my-3"
                name={TABLE_CONTRACT_NON_EMP_LIST.name}
                data={employeeListResponse?.data?.result}
                columns={TABLE_CONTRACT_NON_EMP_LIST.column}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={employeeListResponse?.data?.total_page}
                totalResult={employeeListResponse?.data?.total_result}
                onChangePage={onChangePage}
                loading={employeeListResponse?.isLoading}
            />
        </div>
    )
}
